import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AlertService} from '../../../sdk/service/alert.service';
import {ROUTES} from '../../../app.routes';
import {Account, AccountCreate, BillingType, WebAccountService} from 'web-angular-client';
import {ConfirmationService} from '../../../sdk/service/confirmation.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {Helper} from '../../../sdk/util/helper';

@Component({
    selector: 'app-payment-request-create',
    templateUrl: './payment-request-create.component.html',
    styleUrls: ['./payment-request-create.component.scss'],
    standalone: false
})
export class PaymentRequestCreateComponent implements OnInit
{
    isQuickPay = false;

    constructor(
        protected router: Router,
        protected alertService: AlertService,
        private ngxLoader: NgxUiLoaderService,
        private accountService: WebAccountService,
        private confirmationService: ConfirmationService)
    {
    }

    ngOnInit()
    {
        this.isQuickPay = this.router.url.includes(ROUTES.SECURE.ACCOUNT.QUICK_PAY_CREATE.path);
    }

    onAccountSubmission(account: Account)
    {
        this.confirmationService.confirm(
            'Create Request to Pay Transaction',
            this.getConfirmationMessage(account))
            .then((confirmed) =>
            {
                if (confirmed)
                {
                    this.ngxLoader.start();
                    this.accountService.createAccount(this.mapAccountToCreateAccount(account))
                        .subscribe({
                            next: (account) =>
                            {
                                this.ngxLoader.stop();
                                if (this.isQuickPay)
                                {
                                    this.router.navigate(
                                        [ROUTES.SECURE.ACCOUNT.QUICK_PAY_SEND.pathSansParameters, account.id],
                                        {queryParams: {isQuickPay: this.isQuickPay}}).then();
                                }
                                else
                                {
                                    this.router.navigate(
                                        [ROUTES.SECURE.ACCOUNT.SEND.pathSansParameters, account.id],
                                        {queryParams: {isQuickPay: this.isQuickPay}}).then();
                                }
                            },
                            error: (error) =>
                            {
                                this.ngxLoader.stop();
                                this.alertService.error(error);
                            }
                        });
                }
            });
    }

    mapAccountToCreateAccount(account: Account): AccountCreate
    {
        const accountCreate = {} as AccountCreate;

        accountCreate.lineItems = account.lineItems;
        accountCreate.amount = account.amount;
        accountCreate.minimumAmount = account.minimumAmount;
        accountCreate.maximumAmount = account.maximumAmount;
        accountCreate.multiPremium = account.multiPremium;
        accountCreate.customer = account.customer;
        accountCreate.customerMobileNumber = account.customerMobileNumber;
        accountCreate.customerEmail = account.customerEmail;
        accountCreate.customerVatNumber = account.customerVatNumber;
        accountCreate.accountNumber = account.accountNumber;
        accountCreate.referenceNumber = account.referenceNumber;
        accountCreate.description = account.description;
        accountCreate.billingType = BillingType.INVOICE;
        accountCreate.notificationMobileNumber = account.notificationMobileNumber;
        accountCreate.dateTimeExpire = account.dateTimeExpire;

        return accountCreate;
    }

    private getConfirmationMessage(account: Account): string
    {
        const amountInMajor = Helper.convertToMajorDenomination(account.amount).toFixed(2);
        const baseMessage = `Are you sure you wish to create a request to pay for R${amountInMajor}`;
        const multiples = account.multiPremium !== null ? ` for up to ${account.multiPremium} times with multi premium` : ' transaction';
        return `${baseMessage}${multiples}, issued to ${account.customer}?`;
    }
}